import { POST_UNPREPARE, POST_UNPREPARE_SUCCESS, POST_UNPREPARE_FAILURE } from 'modules/appointmentTask/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

const initialState = {
  isLoading: false,
  apiError: null,
};

const fetchUnprepareReducer = state => ({
  ...state,
  isLoading: true,
  apiError: null,
});

const unprepareSuccessReducer = state => ({
  ...state,
  isLoading: false,
});

const unprepareFailureReducer = (state, { payload }) => ({
  ...state,
  isLoading: false,
  apiError: payload.message,
});

export default createReducer(initialState, {
  [POST_UNPREPARE]: fetchUnprepareReducer,
  [POST_UNPREPARE_SUCCESS]: unprepareSuccessReducer,
  [POST_UNPREPARE_FAILURE]: unprepareFailureReducer,
});
